export enum UserRoles {
	User = 'USER',
	Admin = 'ADMIN',
	Visitor = 'VISITOR'
}
